export default function rowColToLetterCol(row, col) {
  return `${"KJIHGFEDCBA".charAt(row)}${col}`;
};
